import { Link } from "react-router-dom";
import { dramas } from "@/mocks/dramas";
import { formatDate } from "@/utils/content";

export default function DramaHighlights() {
  const items = dramas.slice(0, 5);

  return (
    <div className="flex flex-col divide-y divide-background-200">
      {items.map((item, index) => (
        <Link
          key={item.id}
          to={`/detail/${item.id}`}
          className="group flex gap-4 py-5 first:pt-0"
        >
          <div className="relative hidden h-24 w-36 shrink-0 overflow-hidden rounded-md bg-background-200 sm:block">
            <img
              src={item.cover}
              alt={item.title}
              title={`${item.title} - 我妻子的一切`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute left-0 top-0 flex h-6 items-center bg-primary-800/90 px-2 font-heading text-xs text-background-50">
              {String(index + 1).padStart(2, "0")}
            </span>
          </div>
          <div className="min-w-0 flex-1">
            <div className="mb-1.5 flex flex-wrap items-center gap-2 text-xs text-foreground-400">
              <span className="rounded bg-primary-100 px-1.5 py-0.5 text-primary-800">剧情</span>
              <span>{formatDate(item.date)}</span>
              <span className="hidden sm:inline">· {item.readTime}</span>
            </div>
            <h3 className="line-clamp-2 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
              {item.title}
            </h3>
            <p className="mt-1.5 line-clamp-2 text-sm leading-6 text-foreground-500">
              {item.summary}
            </p>
            <div className="mt-2 flex flex-wrap gap-1.5">
              {item.tags.slice(0, 3).map((tag) => (
                <span key={tag} className="text-xs text-accent-700">
                  #{tag}
                </span>
              ))}
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}